import { Stack, Typography } from "@mui/material";
import { MprcContainer, MprcTypography } from "components";
import { PublicationPanelDto } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
    viewData: PublicationPanelDto[];
}

/**
 * Painel lateral "Últimas publicações"
 * @param props
 */
export const PanelLatestPublication: React.FC<IProps> = (props) => {
    const { viewData } = props;
    const { t } = useTranslation("knowledge");

    return viewData.length > 0
        ? (
            <>
                <MprcContainer margin="dense">
                    <Typography variant="h3" marginBottom={1}>{t("Feed.Panels.LatestPublication.Title")}</Typography>
                </MprcContainer>
                <Stack direction="column" spacing={2}>
                    {
                        viewData.map((item) => {
                            return (
                                <Link key={item.publicationId} to={KnowledgePaths.PublicationViewerResolver(item.publicationId, item.publicationType, item.parentPublicationId)}>
                                    <MprcTypography variant="h6" noWrapRows={2}>
                                        {item.title}
                                    </MprcTypography>
                                </Link>
                            );
                        })
                    }
                </Stack>
            </>
        )
        : null;
};
